import React, { useEffect, useState } from "react";
import "./Add.css";
import { backend, API_URL } from "../../../config";
import { Container, CssBaseline, Grid, Button, Modal } from "@mui/material";
import { makeStyles } from "@mui/styles";
import StepperWarehouses from "./../../../components/Steppers/Warehouses/Warehouses";

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const WarehouseAdd = (props) => {
  const classes = useStyles();
  const warehouseId = props.match.params.id;

  const [confirmModal, setConfirmModal] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [responseModal, setResponseModal] = useState(false);
  const [warehouse, setWarehouse] = useState({
    name: "",
    csv_header_mapping: {},
    unit_type_mapping: {},
  });
  const [warehouseHeaders, setWarehouseHeaders] = useState([]);
  const [warehouseFields, setWarehouseFields] = useState([]);
  const [warehouseUnits, setWarehouseUnits] = useState([]);
  const [warehouseMap, setWarehouseMap] = useState({});
  const [warehouseMapCategory, setWarehouseMapCategory] = useState([]);

  const steps = [
    "Warehouse Information",
    "Warehouse Receipt",
    "Warehouse Mapping",
  ];

  const handleChange = (e) => {
    const { checked, name, value } = e.target;

    setWarehouse((prevState) => ({
      ...prevState,
      [name]: name === "somethingChecked" ? checked : value,
    }));
  };

  const handleMappingChange = (e) => {
    const { name, value } = e.target;

    const fieldName = name.replace("select-", "");

    setWarehouseMap((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }));
  };

  const handleHeadersChange = (headers) => {
    setWarehouseHeaders(headers);
  };

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const confirmModalContent = (
    <div className={classes.modal}>
      Are you sure you want to {!isNaN(warehouseId) ? " update " : " add "}
      the warehouse <b>{warehouse.name}</b>
      <div align="right">
        <Button onClick={() => toggleConfirmModal()} className={classes.button}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => sendRequest()}
          className={classes.button}
        >
          Confirm
        </Button>
      </div>
    </div>
  );

  const toggleResponseModal = () => setResponseModal(!responseModal);

  const responseModalContent = (
    <div className={classes.modal}>
      {errorInfo.error ? (
        <>
          There was an error
          {!isNaN(warehouseId) ? " updating " : " adding "}
          the warehouse <b>{warehouse.name}</b>
          <br />
          <br />
          <span
            style={{
              color: "red",
              wordBreak: "break-word",
              maxHeight: 160,
              overflow: "hidden",
              display: "inline-block",
            }}
          >
            <b>Error:</b>
            <br />
            {errorInfo.message}
          </span>
        </>
      ) : (
        <>
          Warehouse <b>{warehouse.name}</b> has been successfully
          {!isNaN(warehouseId) ? " updated " : " added "}
        </>
      )}
      <div align="right">
        <Button
          variant="contained"
          color="primary"
          onClick={() => resolveRequest()}
          className={classes.button}
        >
          Continue
        </Button>
      </div>
    </div>
  );

  let responses = [];

  const sendRequest = async () => {
    const warehouseObj = {
      name: warehouse.name,
    };

    if (warehouseId && !isNaN(warehouseId)) {
      warehouseMappingSave(warehouseId);
    } else {
      let warehouseId = 0;
      await backend
        .post(`${API_URL}warehouses`, [warehouseObj])
        .then(({ data }) => {
          warehouseId = data[0].pk;
          warehouseMappingSave(warehouseId);
        })
        .catch((error) => {
          console.log(error);
          setErrorInfo({
            error: true,
            message: JSON.stringify(error.response.data),
          });
          toggleResponseModal();
        });
    }

    await backend
      .put(`${API_URL}warehouses/${warehouseId}`, warehouseObj)
      .then((response) => {
        warehouseMapCategoryGet();
      })
      .catch((error) => {
        console.log(error);
        setErrorInfo({
          error: true,
          message: JSON.stringify(error.response.data),
        });
        toggleResponseModal();
      })
      .finally(() => {
        toggleResponseModal();
      });
  };

  const warehouseMappingSave = async (warehouseId) => {
    const mapHeaders = Object.keys(warehouse.mapping);
    const warehouseHeadersMap = mapHeaders.map((item) => {
      return {
        field: warehouse.mapping[item],
        warehouse: warehouseId,
        category: item,
      };
    });
    warehouseHeadersMap.forEach(async (item) => {
      const wmc = warehouseMapCategory
        .filter((wmcItem) => wmcItem.brand === +warehouseId)
        .find((wmcItem) => wmcItem.category === item.category);

      if (wmc) {
        await backend
          .put(`${API_URL}warehousesmaps/${wmc.pk}`, item)
          .then(({ data }) => {
            responses.push(data[0]);
          })
          .catch((error) => {
            console.log(error);
            setErrorInfo({
              error: true,
              message: JSON.stringify(error.response.data),
            });
            toggleResponseModal();
          });
      } else {
        await backend
          .post(`${API_URL}warehousesmaps/`, [item])
          .then(({ data }) => {
            responses.push(data[0]);
          })
          .catch((error) => {
            console.log(error);
            setErrorInfo({
              error: true,
              message: JSON.stringify(error.response.data),
            });
            toggleResponseModal();
          });
      }
    });
  };

  const resolveRequest = () => {
    props.history.push("/setup");
  };

  const warehouseMapCategoryGet = async () => {
    await backend
      .get(`${API_URL}receiptformats?no_page=1`)
      .then(({ data }) => {
        setWarehouseMapCategory(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    handleChange({
      target: {
        name: "mapping",
        value: warehouseMap,
      },
    });
  }, [warehouseMap]);

  useEffect(() => {
    const warehouseFieldsGet = async () => {
      await backend
        .get(`${API_URL}receiptlineheaders?no_page=1`)
        .then(({ data }) => {
          const warehouseFieldsMap = data.filter(
            (item) => !["pk"].includes(item)
          );
          setWarehouseFields(warehouseFieldsMap);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const warehouseUnitTypesGet = async () => {
      await backend
        .get(`${API_URL}receiptlineunittypemappings?no_page=1`)
        .then(({ data }) => {
          const warehouseUnitTypesMap = data.filter(
            (item) => !["pk"].includes(item)
          );
          setWarehouseUnits(warehouseUnitTypesMap);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    warehouseFieldsGet();
    warehouseUnitTypesGet();
  }, []);

  useEffect(() => {
    /* const warehouseGet = async () => {
      await backend
        .get(`${API_URL}warehouse/${warehouseId}`)
        .then(({ data }) => {
          let warehouseObj = {
            pk: data.pk,
            name: data.name,
            mapping: {},
          };
          if (warehouseId) {
            warehouseObj = { ...warehouseObj, pk: data.pk };
          }
          setWarehouse(warehouseObj);
        })
        .catch((error) => {
          console.log(error);
        });
    }; */

    const warehouseGet = () => {
      let warehouseObj = {
        id: 2,
        name: "Restaurant Depot",
        csv_header_mapping: {
          UPC: "product",
          Qty: "quantity",
          "C/U": "unit_type",
          "Ext. Value": "total",
        },
        unit_type_mapping: {},
      };
      setWarehouse(warehouseObj);
    };

    if (!isNaN(warehouseId)) {
      warehouseGet();
      warehouseMapCategoryGet();
    }
  }, [warehouseId]);

  useEffect(() => {
    const warehouseMapMapping = () => {
      let warehouseMappingDict = {};
      warehouseMapCategory
        .filter((item) => item.warehouse === +warehouseId)
        .forEach((item) => {
          if (!warehouseMappingDict.hasOwnProperty(item.category)) {
            warehouseMappingDict[item.category] = item.field;
          }
        });
      setWarehouseMap(warehouseMappingDict);
    };

    if (warehouseMapCategory.length && warehouseFields.length) {
      warehouseMapMapping();
    }
  }, [warehouseId, warehouseMapCategory, warehouseFields]);

  return (
    <>
      <CssBaseline />
      <Container maxWidth="lg" className="container">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Modal open={confirmModal} onClose={toggleConfirmModal}>
              {confirmModalContent}
            </Modal>
            <Modal open={responseModal} onClose={toggleResponseModal}>
              {responseModalContent}
            </Modal>
            <StepperWarehouses
              {...props}
              handleChange={handleChange}
              handleMappingChange={handleMappingChange}
              handleHeadersChange={handleHeadersChange}
              steps={steps}
              toggleConfirmModal={toggleConfirmModal}
              warehouse={warehouse}
              warehouseFields={warehouseFields}
              warehouseHeaders={warehouseHeaders}
              warehouseUnits={warehouseUnits}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default WarehouseAdd;
